import { FgaUserState, type MinimalUser } from '@/generated/model';

import type { UserAccessState } from '../types/UserAccessState';

const ADD_USER_FEATURE = 'feature:add_user';

type UserManagementUser = Pick<MinimalUser, 'extraFeatures'> & Partial<Pick<MinimalUser, 'isAnyAdmin'>>;

type UserAccessIdentity = Pick<MinimalUser, 'extraFeatures' | 'id' | 'isTokenUser'>;

export function canAccessUserAccessControl(user: Pick<MinimalUser, 'isTokenUser'> | undefined): boolean {
  return user !== undefined && !user.isTokenUser;
}

export function canManageUsers(user: UserManagementUser | undefined): boolean {
  return user?.isAnyAdmin === true || user?.extraFeatures?.includes(ADD_USER_FEATURE) === true;
}

export function getUserDetailActions({
  state,
  isCurrentUser,
  canManageUsers,
}: {
  state: UserAccessState;
  isCurrentUser: boolean;
  canManageUsers: boolean;
}) {
  return {
    canEdit: isCurrentUser || canManageUsers,
    canResendInvitation: canManageUsers && state === FgaUserState.WAITING_FOR_ACTIVATION,
  };
}

export function canAccessUser(userId: number, currentUser: UserAccessIdentity | undefined): boolean {
  if (!currentUser || !canAccessUserAccessControl(currentUser) || !Number.isSafeInteger(userId) || userId <= 0) {
    return false;
  }
  return userId === currentUser.id || canManageUsers(currentUser);
}
